import {merge} from '#core/utils/config-utils.js';

import {generatePrimaryButton} from '#core/application/modules/tiles/button/index.js';

export function avantgardeFallbackCardsFactory(PALETTE) {
    const BET_NOW_BUTTON = merge(generatePrimaryButton(PALETTE.FALLBACK_BET_NOW_BUTTON), {
        style: {
            base: {
                flexGrow: 1,
                minHeight: '36px',
            },
        },
    });

    return {
        FallbackEventCard: {
            showBackgroundSportImage: !PALETTE.PARENT.CARD_WATERMARK_ICON_HIDDEN,
            eventCardBase: {
                container: {
                    itemSpacing: '8px',
                    style: {
                        borderColor: PALETTE.FEATURED_ACCENT_BORDER,
                        flexDirection: 'column',
                        alignItems: 'stretch',
                        justifyContent: 'center',
                        padding: '12px',
                        overflow: 'hidden',
                    },
                },
            },
            sportIcon: {
                container: {
                    style: {
                        alignSelf: 'center',
                    },
                },
                icon: {
                    style: {
                        width: '72px',
                        height: '72px',
                    },
                },
            },
            contentContainer: {
                itemSpacing: '6px',
                style: {
                    flexGrow: 0,
                    height: 'auto',
                },
            },
            contentText: {
                truncate: true,
                ellipsisOnLineNumber: 3,
                style: {
                    whiteSpace: 'normal',
                },
            },
            betNowContainer: {
                style: {
                    alignItems: 'stretch',
                    justifyContent: 'center',
                },
            },
            betNowButton: BET_NOW_BUTTON,
        },
    };
}
